import react from "react";
import CustomInput from "../../../../Component/BasicComponents/CustomInput";

const AccountDetails = () => {
  return (
    <div className="">
      <div className="card p-4 shadow-sm">
        <label>
          <h3 style={{ fontSize: "20px", fontWeight: "bold" }}>
            Accout Details
          </h3>
        </label>
        <div className="col-md-12" style={{ display: "flex", gap: "4px" }}>
          <div className="col-md-3">
            <CustomInput
              placeholder=""
              label="Bank Name"
              type="text"
              style={{
                border: "0.2px solid #d4d4d4",
                flex: 1,
              }}
            />
          </div>
          <div className="col-md-3">
            <CustomInput
              placeholder=""
              label="Account Number"
              type="text"
              style={{
                backgroundColor: "transparent",
                border: "0.2px solid #d4d4d4",
                flex: 1,
              }}
            />
          </div>
           <div className="col-md-3">
            <CustomInput
              placeholder=""
              label="Pan No"
              type="text"
              style={{
                border: "0.2px solid #d4d4d4",
                flex: 1,
              }}
            />
          </div>
           <div className="col-md-3">
            <CustomInput
              placeholder=""
              label="GST Number"
              type="text"
              style={{
                backgroundColor: "transparent",
                border: "0.2px solid #d4d4d4",
                flex: 1,
              }}
            />
          </div>
        </div>
        <div className="col-md-12" style={{ display: "flex", gap: "4px" }}>
          <div className="col-md-3">
            <CustomInput
              placeholder=""
              label="Billing Name"
              type="text"
              style={{
                border: "0.2px solid #d4d4d4",
                flex: 1,
              }}
            />
          </div>
          <div className="col-md-3">
            <CustomInput
              placeholder=""
              label="SAP Code"
              type="text"
              style={{
                backgroundColor: "transparent",
                border: "0.2px solid #d4d4d4",
                flex: 1,
              }}
            />
          </div>
          

             <div className="col-md-3">
            <CustomInput
              placeholder=""
              label="Default Sale PriceBook"
              type="text"
              style={{
                border: "0.2px solid #d4d4d4",
                flex: 1,
              }}
            />
          </div>
          <div className="col-md-3">
            <CustomInput
              placeholder=""
              label="Defalut Product Category"
              type="text"
              style={{
                backgroundColor: "transparent",
                border: "0.2px solid #d4d4d4",
                flex: 1,
                
                display:"flex",
                flexWrap:'wrap',
                wordWrap:'break-word'
              }}
            />
            </div>
        </div>
    
        <button
          onClick={() => alert("save Account Form")}
          className="btn btn-primary"
        >
          Save Changes
        </button>
      </div>
    </div>
  );
};
export default AccountDetails;
